import { formatCurrency, formatNumber } from '@angular/common';

export class NumberUtil {
  static readonly LOCALE_FR = 'fr-FR';
  static readonly EURO_SYMBOL = '€';
  static readonly ALLOWED_NUMBERS = /^\d+(\.\d\d?)?$/;

  static formatStringWithUnitToNumber(value: string, factionDigits = 2, locale: string = NumberUtil.LOCALE_FR): number | undefined {
    if (value) {
      try {
        const thousandSeparator = Intl.NumberFormat(locale)
          .format(11111)
          .replace(/\p{Number}/gu, '');
        const decimalSeparator = Intl.NumberFormat(locale)
          .format(1.1)
          .replace(/\p{Number}/gu, '');
        return parseFloat(parseFloat(value.replace(new RegExp('\\' + thousandSeparator, 'g'), '').replace(new RegExp('\\' + decimalSeparator), '.')).toFixed(factionDigits));
      } catch (e) {
        return;
      }
    }
    return;
  }

  static formatNumberToCurrencyString(value?: number, locale: string = NumberUtil.LOCALE_FR, symbol: string = NumberUtil.EURO_SYMBOL): string {
    if (value != null && value >= 0) {
      return formatCurrency(value, locale, symbol);
    }
    return '';
  }

  static formatNumberToPercentString(value: number | undefined, locale: string = NumberUtil.LOCALE_FR): string {
    if (value) {
      return formatNumber(value, locale, '1.2-2');
    }
    return '';
  }

  static formatNumberToStringWithUnit(value?: number, unit: string = ''): string {
    if (value != null && value >= 0) {
      return `${value} ${unit}`;
    }
    return '';
  }
}
